export const NAV_LINKS = [
  { path: "/", label: "Home" },
  { path: "/services", label: "Services" },
  { path: "/work", label: "Work" },
  { path: "/about", label: "About" },
  { path: "/contact", label: "Contact" },
];

export const CONTACT = {
  email: "Nikosmilligan@novodigitalstudio.co.uk",
  phone: "07808 697316",
};
